import {LocalStorage} from './local-store';

export const localStore = new LocalStorage();
